import { connect } from 'react-redux'
import { lifecycle, compose, branch, renderComponent } from 'recompose'
import withType from 'components/common/hoc/withType'
import withScrollToHash from 'components/common/hoc/withScrollToHash'
import { getCurrentStore, getCurrentStoreEnableAppointmentFlag, getCurrentStoreNumber } from 'selectors/getCurrentStore'
import { getAppointmentDate } from 'selectors/getAppointments'
import { getQuoteTotalCount, getProducts } from 'selectors/shoppingData'
import { getLocationPathname } from 'selectors/getPageLocation'
import { setDateData } from '../actions'
import BOTDateTimeSelector from './BOTDateTimeSelector'
import AppointmentIsNotEnable from './components/AppointmentIsNotEnable'
import isEqual from 'lodash/isEqual'
import { arrayHasValues } from 'helpers/utils'
import { isQuotePage } from 'helpers/quoteRelatedPages'
import { getAppointmentDatesAndSlots } from './actions'
import { getActiveVehicleId } from 'selectors/getActiveVehicle'

const mapStateToProps = state => ({
  dates: getAppointmentDate(state),
  appointmentEnable: getCurrentStoreEnableAppointmentFlag(state),
  hasStore: Boolean(getCurrentStore(state)),
  isQuotePage: isQuotePage(getLocationPathname(state)),
  isCartEmpty: !getQuoteTotalCount(state),
  skusAddedToCart: state.addToQuote.skusAddedToCart,
  quoteTotalCount: getQuoteTotalCount(state),
  products: getProducts(state),
  activeVehicleId: getActiveVehicleId(state),
  storeNumber: getCurrentStoreNumber(state)
})

const withAppointmentIsNotEnable = branch(
  ({ appointmentEnable, hasStore }) => hasStore && !appointmentEnable,
  renderComponent(AppointmentIsNotEnable)
)

const withLifecycle = lifecycle({
  componentDidMount() {
    const {
      appointmentDetailsResponseVO: {
        appointmentDateAndSlotsVO: data = []
      } = {},
      setDateData
    } = this.props

    arrayHasValues(data) && setDateData(data)
  },
  componentDidUpdate({
    isCartEmpty: prevIsCartEmpty
  }) {
    const {
      isCartEmpty,
      setDateData,
      isQuotePage
    } = this.props

    !prevIsCartEmpty && isCartEmpty && isQuotePage && setDateData(null)
  },
  UNSAFE_componentWillReceiveProps({
    appointmentDetailsResponseVO: {
      appointmentDateAndSlotsVO: newData = null
    } = {}
  }) {
    const {
      appointmentDetailsResponseVO: {
        appointmentDateAndSlotsVO
      } = {},
      setDateData,
      dates
    } = this.props

    if (!isEqual(appointmentDateAndSlotsVO, newData) || (!dates && newData)) {
      setDateData(newData)
    }
  }
})

export default compose(
  withType({ type: 'BOTDateTimeSelector' }),
  connect(mapStateToProps, {
    setDateData,
    getAppointmentDatesAndSlots
  }),
  withAppointmentIsNotEnable,
  withLifecycle,
  withScrollToHash
)(BOTDateTimeSelector)
